import { PriorityEnumEnumType } from '@mark43/cad-api';
import { AdditionalInfoView, Priority } from '../../types';

export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export enum ListDirection {
    HISTORIC = 'HISTORIC',
    CATCHUP = 'CATCHUP',
}

export type UnreadInfos = {
    [Priority.STANDARD]: null | UnreadInfo;
    [Priority.HIGH]: null | UnreadInfo;
};

export type UnreadInfo = { id: number; priority: PriorityEnumEnumType };

export type AdditionalInfoNotificationManager = {
    hasUnread: boolean;
    unreadInfos: UnreadInfos;
    markAsRead: (infos: AdditionalInfoView[], immediate?: boolean) => Promise<void>;
    earliestUnreadInfo: { id: number } | null;
};
